/* eslint-disable max-len */
import checkIndexOf from './checkIndexOf'
import getPackageKeyFromPathname from './getPackageKeyFromPathname'
import is_server from './is_server'

/**
 * List of constants used to form Itinerary and costing paths
 */
const ITINERARY_VIEW = 'view'
const INCLUSIONS_VIEW = 'inclusions'
const GET_COST = 'get-cost'
const DEPARTURE_CITY = 'departure-city'
const ARRIVAL_CITY = 'arrival-city'
const DEPARTURE_DATE = 'departure-date'
const DURATION = 'duration'
const ROOM_INFO = 'room-info'
const EDIT_TITLE = 'edit-title'
const UPDATE_COST = 'update-cost'
const EDIT_TRIP = 'edit-trip'
const LOGIN = 'login'
const SIGNUP = 'signup'
const SHARE_ITINERARY = 'share-itinerary'
const CBR = 'request-callback'
const CBR_WHATSAPP = 'request-whatsapp-chat'
const HOTEL_DETAILS = 'hotel-details'
const ROOM_DETAILS = 'room-details'
const WATERSPORTS_GALLERY = 'watersports'
const PROPERTY_GALLERY = 'property'
const HIGHLIGHTS_GALLERY = 'highlights'
const IMAGE_GALLERY_KEY = 'image-gallery'
const IMAGE_GALLERY = 'hotel-details/image-gallery'
const ALTERNATE_IMAGE_GALLERY = 'alternate-hotels/image-gallery'
const HOTEL_ALTERNATES = 'alternate-hotels'
const HOTEL_ALTERNATES_DETAILS = 'alternate-hotel-details'
const HOTEL_ALTERNATE_ROOMS = 'alternate-hotels/alternate-rooms'
const ACTIVITY_DETAILS = 'activity-details'
const ACTIVITY_DETAILS_PREVIEW = 'activity-preview'
const ACTIVITY_ALTERNATES = 'alternate-activities'
const ACTIVITY_ALTERNATES_DETAILS = 'alternate-activities-details'
const FLIGHT_DETAILS = 'flight-details'
const FLIGHT_ALTERNATES = 'alternate-flights'
const ALTERNATE_FLIGHTS_DETAIL = 'alternate-flights-details'
const TRAIN_DETAILS = 'train-details'
const TRAIN_ALTERNATES = 'alternate-trains'
const BUS_ALTERNATES = 'alternate-buses'
const BUS_DETAILS = 'bus-details'
const FERRY_ALTERNATES = 'alternate-ferries'
const FERRY_DETAILS = 'ferry-details'
const RENTAL_CAR_DETAILS = 'rental-car-details'
const RENTAL_CAR_ALTERNATES = 'alternate-rental-cars'
const CHANGE_RENTAL_CAR_INSURANCE = 'change-rc-insurance'
const ALTERNATE_TRANSFER_MODE = 'alternate-travel-mode'
const RATE_MATCH = 'rate-match'
const COSTING_IN_PROGRESS = 'calculating-cost'
const EMAIL_QUOTE = 'email-quote'
const EMAIL_QUOTE_ADMIN = 'share-email-quote'
const CHANGE_INSURANCE = 'change-insurance'
const CHANGE_VISA = 'change-visa'
const RATE_MATCH_HOTEL_ROOM = 'rate-match/hotel-room'
const RATE_MATCH_ACTIVITY = 'rate-match/activity'
const RATE_MATCH_RENTAL_CAR = 'rate-match/rental-car'
const RATE_MATCH_FLIGHT = 'rate-match/flight'
const RATE_MATCH_TRAIN = 'rate-match/train'
const RATE_MATCH_FERRY = 'rate-match/ferry'
const RATE_MATCH_TRANSFER = 'rate-match/transfer'
const RATE_MATCH_TOTAL_COST = 'rate-match/total-cost'
const ENABLE_TOTEM = 'enable-totem'
const BEFORE_YOU_BOOK = 'before-you-book'
const COMFY_SCORE = 'comfy-score'
const SPLIT_PRICE = 'split-price'
const CHANGE_LOCALE = 'change-locale'
const SPLIT_HOTEL = 'split-hotel'
const BLOCK_CARD = 'block-card'
const BLOCK_CARD_FLIGHT = 'block-card/flight'
const BLOCK_CARD_HOTEL = 'block-card/hotel'
const BLOCK_CARD_CUSTOM = 'block-card/custom'
const FLIGHT_DETAILS_BLOCK_CARD = 'flight-details/block-card'
const HOTEL_DETAILS_BLOCK_CARD = 'hotel-details/block-card'
const CANCELLATION_POLICY = 'cancellation-policy'
const EMAIL = 'email-quote'

/**
 * PLACEHOLDER CONST
 */
const PH_ITINERARY_ID = ':itineraryId'
const BLOCK_CARD_KEY = ':customKey'
const PH_HOTEL_CODE = ':hotelCode'
const PH_HOTEL_ROOM_KEY = ':hotelRoomKey'
const PH_ALT_HOTEL_ROOM_KEY = ':altHotelRoomKey'
const PH_CONFIG_KEY = ':configKey'
const PH_ACTIVITY_CODE = ':activityId'
const PH_CALLED_FROM_KEY = ':called_from'
const PH_TOTEM_ID_KEY = ':dayIdentifier'
const PH_ROOM_TYPE_ID = ':identifier'
const PH_SEARCH_REGION = ':searchRegion'
const PH_CUSTOMIZE = 'customize'
/**
 * Maldives const
 */
const LANDING_PAGE_KEY = 'maldives-tour-packages'
export const REQUEST_CALLBACK = 'request-callback'
const LISTING = 'listing'
const MALDIVES_SLUG_KEY = '-maldives-resort'
const FILTER_BY_PRICE = 'filter-by-price'
export const EXPLORE_ALL = 'explore-all'
const MALDIVES_INCLUSIONS_BASE_URL = '/customize/mle/inclusions'

// Maldives routes
const SPEEDBOAT_IMAGE_ROUTE = `/resort-image-test`
const LANDING_ROUTE = `/${LANDING_PAGE_KEY}`
const LISTING_ROUTE = `/${LANDING_PAGE_KEY}/${LISTING}`
const RESORT_SLUG_ROUTE = `/:hotelslug${MALDIVES_SLUG_KEY}`
const RESORTS_SLUG_MODAL_ROUTE = `${RESORT_SLUG_ROUTE}/:activetab`

const MALDIVES_RESORTS_CBR_ROUTE = `/${LANDING_PAGE_KEY}/${REQUEST_CALLBACK}/:regionCode`
const MALDIVES_RESORTS_WHATSAPP_ROUTE = `${RESORT_SLUG_ROUTE}/${CBR_WHATSAPP}`
// landing page get cost routes
const MALDIVES_GET_COST_DEPARTURE_CITY_ROUTE = `/${LANDING_PAGE_KEY}/${GET_COST}/${DEPARTURE_CITY}`
const MALDIVES_GET_COST_DEPARTURE_DATE_ROUTE = `/${LANDING_PAGE_KEY}/${GET_COST}/${DEPARTURE_DATE}`
const MALDIVES_GET_COST_DURATION_ROUTE = `/${LANDING_PAGE_KEY}/${GET_COST}/${DURATION}`
const MALDIVES_GET_COST_ROOMS_ROUTE = `/${LANDING_PAGE_KEY}/${GET_COST}/${ROOM_INFO}`

const MALDIVES_LISTING_CBR_ROUTE = `/${LANDING_PAGE_KEY}/${LISTING}/${REQUEST_CALLBACK}`
// Update Cost route for listing page
const MALDIVES_LISTING_GCM_UPDATE_COST_ROUTE = `${LISTING_ROUTE}/${UPDATE_COST}`

const RESORT_SLUG_LOGIN_ROUTE = `${RESORT_SLUG_ROUTE}/login`
const RESORT_SLUG_SIGNUP_ROUTE = `${RESORT_SLUG_ROUTE}/signup`
// get cost routes for resort precosted details page
const RESORT_SLUG_GCM_ROUTE = `${RESORT_SLUG_ROUTE}/${GET_COST}`
const RESORT_SLUG_GCM_DEPARTURE_CITY_ROUTE = `${RESORT_SLUG_GCM_ROUTE}/${DEPARTURE_CITY}`
const RESORT_SLUG_GCM_DEPARTURE_DATE_ROUTE = `${RESORT_SLUG_GCM_ROUTE}/${DEPARTURE_DATE}`
const RESORT_SLUG_GCM_DURATION_ROUTE = `${RESORT_SLUG_GCM_ROUTE}/${DURATION}`
const RESORT_SLUG_GCM_ROOMS_ROUTE = `${RESORT_SLUG_GCM_ROUTE}/${ROOM_INFO}`

const MALDIVES_LISTING_LOGIN = `${LISTING_ROUTE}/login`
const MALDIVES_LISTING_SIGN_UP = `${LISTING_ROUTE}/signup`
const MALDIVES_LANDING_EXPLORE_ALL_ROUTE = `/${LANDING_PAGE_KEY}/${EXPLORE_ALL}`
const MALDIVES_LANDING_FILTER_BY_PRICE = `/${LANDING_PAGE_KEY}/${FILTER_BY_PRICE}`

/**
 * End of maldives route
 */

const ITINERARY_BASE = `/${PH_CUSTOMIZE}/${PH_SEARCH_REGION}/${ITINERARY_VIEW}`
/**
 * List of Itinerary page routes
 */
// customize/idn/view/ID
const ITINERARY_VIEW_ROUTE = `${ITINERARY_BASE}/${PH_ITINERARY_ID}`
// customize/idn/view/edit-trip/ID
const EDIT_TRIP_ROUTE = `${ITINERARY_BASE}/${EDIT_TRIP}/${PH_ITINERARY_ID}`
// customize/idn/view/comfy-score/ID
const COMFY_SCORE_ITINERARY_ROUTE = `${ITINERARY_BASE}/${COMFY_SCORE}/${PH_ITINERARY_ID}`
// customize/idn/view/get-cost/ID
const GET_COST_ROUTE = `${ITINERARY_BASE}/${GET_COST}/${PH_ITINERARY_ID}`
// customize/idn/view/get-cost/departure-city/ID
const GET_COST_DEPARTURE_CITY_ROUTE = `${ITINERARY_BASE}/${GET_COST}/${DEPARTURE_CITY}/${PH_ITINERARY_ID}`
// customize/idn/view/get-cost/departure-date/ID
const GET_COST_DEPARTURE_DATE_ROUTE = `${ITINERARY_BASE}/${GET_COST}/${DEPARTURE_DATE}/${PH_ITINERARY_ID}`
// customize/idn/view/get-cost/duration/ID
const GET_COST_DURATION_ROUTE = `${ITINERARY_BASE}/${GET_COST}/${DURATION}/${PH_ITINERARY_ID}`
// customize/idn/view/get-cost/room-info/ID
const GET_COST_PAX_ROUTE = `${ITINERARY_BASE}/${GET_COST}/${ROOM_INFO}/${PH_ITINERARY_ID}`
// customize/idn/view/edit-title/ID
const EDIT_TITLE_ROUTE = `${ITINERARY_BASE}/${EDIT_TITLE}/${PH_ITINERARY_ID}`
// customize/idn/view/get-cost/ID
const UPDATE_COST_ROUTE = `${ITINERARY_BASE}/${UPDATE_COST}/${PH_ITINERARY_ID}`

const ENABLE_TOTEM_ROUTE = `${ITINERARY_BASE}/${ENABLE_TOTEM}/${PH_TOTEM_ID_KEY}/${PH_ITINERARY_ID}` // customize/idn/view/calculating-cost/ID
const COSTING_IN_PROGRESS_ROUTE = `${ITINERARY_BASE}/${COSTING_IN_PROGRESS}/${PH_ITINERARY_ID}` // customize/idn/view/calculating-cost/ID
const SHARE_ITINERARY_ROUTE = `${ITINERARY_BASE}/${SHARE_ITINERARY}/${PH_ITINERARY_ID}` // customize/idn/view/share-itinerary/ID
const LOGIN_ROUTE = `${ITINERARY_BASE}/${LOGIN}/${PH_ITINERARY_ID}` // customize/idn/view/login/ID
const CBR_ROUTE = `${ITINERARY_BASE}/${CBR}/${PH_ITINERARY_ID}` // customize/idn/view/request-callback/ID
const CBR_WHATSAPP_ROUTE = `${ITINERARY_BASE}/${CBR_WHATSAPP}/${PH_ITINERARY_ID}` // customize/idn/view/request-callback/ID
const SIGNUP_ROUTE = `${ITINERARY_BASE}/${SIGNUP}/${PH_ITINERARY_ID}` // customize/idn/view/signup/ID
const HOTEL_DETAILS_ROUTE = `${ITINERARY_BASE}/${HOTEL_DETAILS}/${PH_CONFIG_KEY}/${PH_ITINERARY_ID}`
const HOTEL_GALLERY_ROUTE = `${ITINERARY_BASE}/${IMAGE_GALLERY}/${PH_CONFIG_KEY}/${PH_ITINERARY_ID}`
const HOTEL_ALTERNATES_ROUTE = `${ITINERARY_BASE}/${HOTEL_ALTERNATES}/${PH_CONFIG_KEY}/${PH_ITINERARY_ID}`
const HOTEL_ALTERNATES_DETAILS_ROUTE = `${ITINERARY_BASE}/${HOTEL_ALTERNATES}/${PH_CONFIG_KEY}/${PH_ITINERARY_ID}/details/${PH_HOTEL_CODE}`
const HOTEL_ALTERNATE_GALLERY_ROUTE = `${ITINERARY_BASE}/${ALTERNATE_IMAGE_GALLERY}/${PH_CONFIG_KEY}/${PH_ITINERARY_ID}/details/${PH_HOTEL_CODE}`
const HOTEL_ALTERNATE_ROOMS_ROUTE = `${ITINERARY_BASE}/${HOTEL_ALTERNATE_ROOMS}/${PH_CONFIG_KEY}/${PH_HOTEL_ROOM_KEY}/${PH_ITINERARY_ID}`
const ACTIVITY_DETAILS_ROUTE = `${ITINERARY_BASE}/${ACTIVITY_DETAILS}/${PH_CONFIG_KEY}/${PH_ITINERARY_ID}`
const ACTIVITY_DETAILS_PREVIEW_ROUTE = `${ITINERARY_BASE}/${ACTIVITY_DETAILS_PREVIEW}/${PH_CONFIG_KEY}/${PH_ITINERARY_ID}`
const ACTIVITY_ALTERNATES_ROUTE = `${ITINERARY_BASE}/${ACTIVITY_ALTERNATES}/${PH_CONFIG_KEY}/${PH_ITINERARY_ID}`
const ACTIVITY_ALTERNATES_DETAILS_ROUTE = `${ITINERARY_BASE}/${ACTIVITY_ALTERNATES}/${PH_CONFIG_KEY}/${PH_ITINERARY_ID}/details/${PH_ACTIVITY_CODE}`
const ALTERNATE_TRANSFER_MODE_ROUTE = `${ITINERARY_BASE}/${ALTERNATE_TRANSFER_MODE}/:currentMode/:prevCityKey/:nextCityKey/${PH_ITINERARY_ID}`
const RATE_MATCH_ACTIVITY_ROUTE = `${ITINERARY_BASE}/${RATE_MATCH_ACTIVITY}/${PH_CONFIG_KEY}/${PH_CALLED_FROM_KEY}/${PH_ITINERARY_ID}`
const RATE_MATCH_TRANSFER_ROUTE = `${ITINERARY_BASE}/${RATE_MATCH_TRANSFER}/${PH_CONFIG_KEY}/${PH_CALLED_FROM_KEY}/${PH_ITINERARY_ID}`
const RATE_MATCH_HOTEL_ROOM_ROUTE = `${ITINERARY_BASE}/${RATE_MATCH_HOTEL_ROOM}/${PH_CONFIG_KEY}/${PH_ROOM_TYPE_ID}/${PH_CALLED_FROM_KEY}/${PH_ITINERARY_ID}`
const RATE_MATCH_TOTAL_ROUTE = `${ITINERARY_BASE}/${RATE_MATCH_TOTAL_COST}/${PH_CALLED_FROM_KEY}/${PH_ITINERARY_ID}`
const BEFORE_YOU_BOOK_ROUTE = `${ITINERARY_BASE}/${BEFORE_YOU_BOOK}/${PH_ITINERARY_ID}`
const COMFY_SCORE_ROUTE = `${ITINERARY_BASE}/${COMFY_SCORE}/${PH_ITINERARY_ID}`
const SPLIT_HOTEL_ROUTE = `${ITINERARY_BASE}/${SPLIT_HOTEL}/:sourceHotelCostingKey/${PH_ITINERARY_ID}/`
const IMAGE_GALLERY_ROUTE_WITH_ITINERARY_ID = `${ITINERARY_BASE}/${PH_ITINERARY_ID}/${IMAGE_GALLERY_KEY}`
const IMAGE_GALLERY_ROUTE = `${ITINERARY_BASE}/${PH_ITINERARY_ID}/${IMAGE_GALLERY_KEY}`
const RATE_MATCH_RENTAL_CAR_ROUTE = `${ITINERARY_BASE}/${RATE_MATCH_RENTAL_CAR}/${PH_CONFIG_KEY}/${PH_CALLED_FROM_KEY}/${PH_ITINERARY_ID}`
const RATE_MATCH_FERRY_ROUTE = `${ITINERARY_BASE}/${RATE_MATCH_FERRY}/${PH_CONFIG_KEY}/${PH_CALLED_FROM_KEY}/${PH_ITINERARY_ID}`
const FERRY_DETAILS_ROUTE = `${ITINERARY_BASE}/${FERRY_DETAILS}/${PH_CONFIG_KEY}/${PH_ITINERARY_ID}`
const FERRY_ALTERNATE_ROUTE = `${ITINERARY_BASE}/${FERRY_ALTERNATES}/${PH_CONFIG_KEY}/${PH_ITINERARY_ID}`
const CHANGE_RENTAL_CAR_INSURANCE_ROUTE = `${ITINERARY_BASE}/${CHANGE_RENTAL_CAR_INSURANCE}/${PH_CONFIG_KEY}/${PH_ITINERARY_ID}`
const ALTERNATE_RENTAL_CAR_ROUTE = `${ITINERARY_BASE}/${RENTAL_CAR_ALTERNATES}/${PH_CONFIG_KEY}/${PH_ITINERARY_ID}`
const RATE_MATCH_FLIGHT_ROUTE = `${ITINERARY_BASE}/${RATE_MATCH_FLIGHT}/${PH_CONFIG_KEY}/${PH_CALLED_FROM_KEY}/${PH_ITINERARY_ID}`
const ALTERNATE_FLIGHTS_ROUTE = `${ITINERARY_BASE}/${FLIGHT_ALTERNATES}/${PH_CONFIG_KEY}/${PH_ITINERARY_ID}`
const ALTERNATE_FLIGHTS_DETAIL_ROUTE = `${ITINERARY_BASE}/${FLIGHT_ALTERNATES}/${PH_CONFIG_KEY}/${PH_ITINERARY_ID}/details`
const FLIGHT_DETAILS_ROUTE = `${ITINERARY_BASE}/${FLIGHT_DETAILS}/${PH_CONFIG_KEY}/${PH_ITINERARY_ID}`
const FLIGHT_DETAILS_BLOCK_CARD_ROUTE = `${ITINERARY_BASE}/${FLIGHT_DETAILS}/${BLOCK_CARD}/${PH_CONFIG_KEY}/${PH_ITINERARY_ID}`
const BLOCK_CARD_HOTEL_ROUTE = `${ITINERARY_BASE}/${BLOCK_CARD_HOTEL}/${PH_CONFIG_KEY}/${PH_ITINERARY_ID}`
const HOTEL_DETAILS_BLOCK_CARD_ROUTE = `${ITINERARY_BASE}/${HOTEL_DETAILS}/${BLOCK_CARD}/${PH_CONFIG_KEY}/${PH_ITINERARY_ID}`
const BLOCK_CARD_FLIGHT_ROUTE = `${ITINERARY_BASE}/${BLOCK_CARD_FLIGHT}/${PH_CONFIG_KEY}/${PH_ITINERARY_ID}`
const EMAIL_QUOTE_ROUTE = `${ITINERARY_BASE}/${EMAIL_QUOTE}/${PH_ITINERARY_ID}`
const EMAIL_QUOTE_ADMIN_ROUTE = `${ITINERARY_BASE}/${EMAIL_QUOTE_ADMIN}/${PH_ITINERARY_ID}`
const INCLUSIONS_BASE = `/${PH_CUSTOMIZE}/${PH_SEARCH_REGION}/${INCLUSIONS_VIEW}`

// inclusions page routes
const inclusionsRoute = {
	// INCLUSIONS_PAGE: "/customize/:searchRegion/inclusions/:itineraryId",
	INCLUSIONS_PAGE: `${INCLUSIONS_BASE}/${PH_ITINERARY_ID}`,
	// UPDATE_COST: "/customize/:searchRegion/inclusions/update-cost/:itineraryId",
	UPDATE_COST: `${INCLUSIONS_BASE}/${UPDATE_COST}/${PH_ITINERARY_ID}`,
	// UPDATE_COST: "/customize/:searchRegion/inclusions/edit-title/:itineraryId",
	EDIT_TITLE_ROUTE: `${INCLUSIONS_BASE}/${EDIT_TITLE}/${PH_ITINERARY_ID}`,
	// EMAIL_QUOTE: "/customize/:searchRegion/inclusions/email-quote/:itineraryId",
	EMAIL_QUOTE: `${INCLUSIONS_BASE}/${EMAIL_QUOTE}/${PH_ITINERARY_ID}`,
	// EMAIL_QUOTE_ADMIN: "/customize/:searchRegion/inclusions/share-email-quote/:itineraryId",
	EMAIL_QUOTE_ADMIN: `${INCLUSIONS_BASE}/${EMAIL_QUOTE_ADMIN}/${PH_ITINERARY_ID}`,
	// SHARE_ITINERARY: "/customize/:searchRegion/inclusions/share-itinerary/:itineraryId",
	SHARE_ITINERARY: `${INCLUSIONS_BASE}/${SHARE_ITINERARY}/${PH_ITINERARY_ID}`,
	// LOGIN: "/customize/:searchRegion/inclusions/login/:itineraryId"
	LOGIN: `${INCLUSIONS_BASE}/${LOGIN}/${PH_ITINERARY_ID}`,
	// SIGNUP: "/customize/:searchRegion/inclusions/signup/:itineraryId",
	SIGNUP: `${INCLUSIONS_BASE}/${SIGNUP}/${PH_ITINERARY_ID}`,
	// REQUEST_WHATSAPP_CHAT: "/customize/:searchRegion/inclusions/request-whatsapp-chat/:itineraryId",
	REQUEST_WHATSAPP_CHAT: `${INCLUSIONS_BASE}/${CBR_WHATSAPP}/${PH_ITINERARY_ID}`,
	// REQUEST_CALLBACK: "/customize/:searchRegion/inclusions/request-callback/:itineraryId",
	REQUEST_CALLBACK: `${INCLUSIONS_BASE}/${CBR}/${PH_ITINERARY_ID}`,
	// COSTING_DELAY: "/customize/:searchRegion/inclusions/calculating-cost/:itineraryId"
	COSTING_DELAY: `${INCLUSIONS_BASE}/calculating-cost/${PH_ITINERARY_ID}`,
	// FLIGHT_DETAILS: "/customize/:searchRegion/inclusions/flight-details/:configKey/:itineraryId"
	FLIGHT_DETAILS: `${INCLUSIONS_BASE}/${FLIGHT_DETAILS}/${PH_CONFIG_KEY}/${PH_ITINERARY_ID}`,
	// ALTERNATE_FLIGHTS: "/customize/:searchRegion/inclusions/alternate-flights/:configKey/:itineraryId"
	ALTERNATE_FLIGHTS: `${INCLUSIONS_BASE}/${FLIGHT_ALTERNATES}/${PH_CONFIG_KEY}/${PH_ITINERARY_ID}`,
	// ALTERNATE_FLIGHTS_DETAIL: "/customize/:searchRegion/inclusions/alternate-flights/:configKey/:itineraryId/details"
	ALTERNATE_FLIGHTS_DETAIL: `${INCLUSIONS_BASE}/${FLIGHT_ALTERNATES}/${PH_CONFIG_KEY}/${PH_ITINERARY_ID}/details`,
	// HOTEL_DETAILS: "/customize/:searchRegion/inclusions/hotel-details/:configKey/:itineraryId"
	HOTEL_DETAILS: `${INCLUSIONS_BASE}/${HOTEL_DETAILS}/${PH_CONFIG_KEY}/${PH_ITINERARY_ID}`,
	// ROOM_DETAILS: "/customize/:searchRegion/inclusions/room-details/:configKey/:hotelRoomKey/:itineraryId"
	ROOM_DETAILS: `${INCLUSIONS_BASE}/${ROOM_DETAILS}/${PH_CONFIG_KEY}/${PH_HOTEL_ROOM_KEY}/${PH_ITINERARY_ID}/${PH_ALT_HOTEL_ROOM_KEY}`,
	// PROPERTY_GALLERY: "/customize/:searchRegion/inclusions/property/:configKey/:hotelRoomKey/:itineraryId"
	PROPERTY_GALLERY: `${INCLUSIONS_BASE}/${PROPERTY_GALLERY}/${PH_CONFIG_KEY}/${PH_HOTEL_ROOM_KEY}/${PH_ITINERARY_ID}/${PH_ALT_HOTEL_ROOM_KEY}`,
	// WATERSPORTS_GALLERY: "/customize/:searchRegion/inclusions/watersports/:configKey/:hotelRoomKey/:itineraryId"
	WATERSPORTS_GALLERY: `${INCLUSIONS_BASE}/${WATERSPORTS_GALLERY}/${PH_CONFIG_KEY}/${PH_HOTEL_ROOM_KEY}/${PH_ITINERARY_ID}/${PH_ALT_HOTEL_ROOM_KEY}`,
	// HIGHLIGHTS_GALLERY: "/customize/:searchRegion/inclusions/highlights/:configKey/:hotelRoomKey/:itineraryId"
	HIGHLIGHTS_GALLERY: `${INCLUSIONS_BASE}/${HIGHLIGHTS_GALLERY}/${PH_CONFIG_KEY}/${PH_HOTEL_ROOM_KEY}/${PH_ITINERARY_ID}/${PH_ALT_HOTEL_ROOM_KEY}`,
	// HOTEL_DETAILS: "/customize/:searchRegion/inclusions/hotel-details/image-gallery/:configKey/:itineraryId"
	HOTEL_GALLERY: `${INCLUSIONS_BASE}/${IMAGE_GALLERY}/${PH_CONFIG_KEY}/${PH_ITINERARY_ID}`,
	// ALTERNATE_HOTEL: "/customize/:searchRegion/inclusions/alternate-hotels/:configKey/:itineraryId"
	ALTERNATE_HOTEL: `${INCLUSIONS_BASE}/${HOTEL_ALTERNATES}/${PH_CONFIG_KEY}/${PH_ITINERARY_ID}`,
	// ALTERNATE_HOTEL_DETAILS: "/customize/:searchRegion/inclusions/alternate-hotel/:configKey/:hotelCode/details/:itineraryId"
	ALTERNATE_HOTEL_DETAILS: `${INCLUSIONS_BASE}/${HOTEL_ALTERNATES}/${PH_CONFIG_KEY}/${PH_ITINERARY_ID}/details/${PH_HOTEL_CODE}`,
	// ALTERNATE_HOTEL_DETAILS: "/customize/:searchRegion/inclusions/alternate-hotel/image-gallery/:configKey/:hotelCode/details/:itineraryId"
	ALTERNATE_HOTEL_GALLERY: `${INCLUSIONS_BASE}/${ALTERNATE_IMAGE_GALLERY}/${PH_CONFIG_KEY}/${PH_ITINERARY_ID}/details/${PH_HOTEL_CODE}`,
	// ALTERNATE_ROOM: "/customize/:searchRegion/inclusions/alternate-hotels/alternate-rooms/:configKey/:hotelRoomKey/:itineraryId"
	ALTERNATE_ROOM: `${INCLUSIONS_BASE}/${HOTEL_ALTERNATE_ROOMS}/${PH_CONFIG_KEY}/${PH_HOTEL_ROOM_KEY}/${PH_ITINERARY_ID}`,
	// ACTIVITY_DETAILS: "/customize/:searchRegion/inclusions/activity-details/:configKey/:itineraryId"
	ACTIVITY_DETAILS: `${INCLUSIONS_BASE}/activity-details/${PH_CONFIG_KEY}/${PH_ITINERARY_ID}`,
	// ACTIVITY_DETAILS_PREVIEW: "/customize/:searchRegion/inclusions/activity-preview/:configKeyineraryId"
	ACTIVITY_DETAILS_PREVIEW: `${INCLUSIONS_BASE}/activity-preview/${PH_CONFIG_KEY}/${PH_ITINERARY_ID}`,
	// ALTERNATE_ACTIVITY: "/customize/:searchRegion/inclusions/alternate-activities/:configKeyineraryId"
	ALTERNATE_ACTIVITY: `${INCLUSIONS_BASE}/alternate-activities/${PH_CONFIG_KEY}/${PH_ITINERARY_ID}`,
	// ALTERNATE_ACTIVITY: "/customize/:searchRegion/inclusions/alternate-activities/:configKey/:itineraryId"
	ALTERNATE_ACTIVITY_DETAILS: `${INCLUSIONS_BASE}/alternate-activities/${PH_CONFIG_KEY}/${PH_ITINERARY_ID}/details/${PH_ACTIVITY_CODE}`,
	// CHANGE_INSURANCE: "/customize/:searchRegion/inclusions/change-insurance/:itineraryId"
	CHANGE_INSURANCE: `${INCLUSIONS_BASE}/${CHANGE_INSURANCE}/${PH_ITINERARY_ID}`,
	// CHANGE_VISA: "/customize/:searchRegion/inclusions/change-visa/:visaKey/:itineraryId"
	CHANGE_VISA: `${INCLUSIONS_BASE}/${CHANGE_VISA}/:visaKey/${PH_ITINERARY_ID}`,
	// TRAIN_DETAILS: "/customize/:searchRegion/inclusions/train-details/:configKey/:itineraryId"
	TRAIN_DETAILS: `${INCLUSIONS_BASE}/${TRAIN_DETAILS}/${PH_CONFIG_KEY}/${PH_ITINERARY_ID}`,
	// TRAIN_ALTERNATE: "/customize/:searchRegion/inclusions/alternate-trains/:configKey/:itineraryId"
	TRAIN_ALTERNATE: `${INCLUSIONS_BASE}/${TRAIN_ALTERNATES}/${PH_CONFIG_KEY}/${PH_ITINERARY_ID}`,
	// RATE_MATCH_ACTIVITY: "/customize/:searchRegion/inclusions/rate-match/activity/:configKey/:called_from/:itineraryId"
	RATE_MATCH_ACTIVITY: `${INCLUSIONS_BASE}/${RATE_MATCH_ACTIVITY}/${PH_CONFIG_KEY}/${PH_CALLED_FROM_KEY}/${PH_ITINERARY_ID}`,
	// RATE_MATCH_FLIGHT: "/customize/:searchRegion/inclusions/rate-match/flight/:configKey/:called_from/:itineraryId"
	RATE_MATCH_FLIGHT: `${INCLUSIONS_BASE}/${RATE_MATCH_FLIGHT}/${PH_CONFIG_KEY}/${PH_CALLED_FROM_KEY}/${PH_ITINERARY_ID}`,
	// RATE_MATCH_RENTAL_CAR: "/customize/:searchRegion/inclusions/rate-match/rental-car/:configKey/:called_from/:itineraryId"
	RATE_MATCH_RENTAL_CAR: `${INCLUSIONS_BASE}/${RATE_MATCH_RENTAL_CAR}/:configKey/${PH_CALLED_FROM_KEY}/${PH_ITINERARY_ID}`,
	// RATE_MATCH_TRAIN: "/customize/:searchRegion/inclusions/rate-match/train/:configKey/:called_from/:itineraryId"
	RATE_MATCH_TRAIN: `${INCLUSIONS_BASE}/${RATE_MATCH_TRAIN}/${PH_CONFIG_KEY}/${PH_CALLED_FROM_KEY}/${PH_ITINERARY_ID}`,
	// RATE_MATCH_FERRY: "/customize/:searchRegion/inclusions/rate-match/ferry/:configKey/:called_from/:itineraryId"
	RATE_MATCH_FERRY: `${INCLUSIONS_BASE}/${RATE_MATCH_FERRY}/${PH_CONFIG_KEY}/${PH_CALLED_FROM_KEY}/${PH_ITINERARY_ID}`,
	// RATE_MATCH_TRANSFER: "/customize/:searchRegion/inclusions/rate-match/transfer/:configKey/:called_from/:itineraryId"
	RATE_MATCH_TRANSFER: `${INCLUSIONS_BASE}/${RATE_MATCH_TRANSFER}/${PH_CONFIG_KEY}/${PH_CALLED_FROM_KEY}/${PH_ITINERARY_ID}`,
	// RATE_MATCH_HOTEL_ROOM: "/customize/:searchRegion/inclusions/rate-match/hotel-room/:configKey/:identifier/:called_from/:itineraryId"
	RATE_MATCH_HOTEL_ROOM: `${INCLUSIONS_BASE}/${RATE_MATCH_HOTEL_ROOM}/${PH_CONFIG_KEY}/${PH_ROOM_TYPE_ID}/${PH_CALLED_FROM_KEY}/${PH_ITINERARY_ID}`,
	// RATE_MATCH_TOTAL_COST: "/customize/:searchRegion/inclusions/rate-match/total-cost/:called_from/:itineraryId"
	RATE_MATCH_TOTAL_COST: `${INCLUSIONS_BASE}/${RATE_MATCH_TOTAL_COST}/${PH_CALLED_FROM_KEY}/${PH_ITINERARY_ID}`,
	// RENTAL_CAR_DETAILS: "/customize/:searchRegion/inclusions/rental-car-details/:configKey/:itineraryId"
	RENTAL_CAR_DETAILS: `${INCLUSIONS_BASE}/${RENTAL_CAR_DETAILS}/${PH_CONFIG_KEY}/${PH_ITINERARY_ID}`,
	// CHANGE_RENTAL_CAR_INSURANCE: "/customize/:searchRegion/inclusions/change-rc-insurance/:configKey/:itineraryId"
	CHANGE_RENTAL_CAR_INSURANCE: `${INCLUSIONS_BASE}/${CHANGE_RENTAL_CAR_INSURANCE}/${PH_CONFIG_KEY}/${PH_ITINERARY_ID}`,
	// ALTERNATE_RENTAL_CAR: "/customize/:searchRegion/inclusions/alternate-rental-cars/:configKey/:itineraryId"
	ALTERNATE_RENTAL_CAR: `${INCLUSIONS_BASE}/${RENTAL_CAR_ALTERNATES}/${PH_CONFIG_KEY}/${PH_ITINERARY_ID}`,
	// BUS_ALTERNATE: "/customize/:searchRegion/inclusions/alternate-buses/:configKey/:itineraryId"
	BUS_ALTERNATE: `${INCLUSIONS_BASE}/${BUS_ALTERNATES}/${PH_CONFIG_KEY}/${PH_ITINERARY_ID}`,
	// FERRY_ALTERNATE: "/customize/:searchRegion/inclusions/alternate-ferries/:configKey/:itineraryId"
	FERRY_ALTERNATE: `${INCLUSIONS_BASE}/${FERRY_ALTERNATES}/${PH_CONFIG_KEY}/${PH_ITINERARY_ID}`,
	// BUS_DETAILS: "/customize/:searchRegion/inclusions/bus-details/:configKey/:itineraryId"
	BUS_DETAILS: `${INCLUSIONS_BASE}/${BUS_DETAILS}/${PH_CONFIG_KEY}/${PH_ITINERARY_ID}`,
	// FERRY_DETAILS: "/customize/:searchRegion/inclusions/ferry-details/:configKey/:itineraryId"
	FERRY_DETAILS: `${INCLUSIONS_BASE}/${FERRY_DETAILS}/${PH_CONFIG_KEY}/${PH_ITINERARY_ID}`,
	// BEFORE_YOU_BOOK_ROUTE: "/customize/:searchRegion/inclusions/before-you-book/:itineraryId"
	BEFORE_YOU_BOOK_ROUTE: `${INCLUSIONS_BASE}/${BEFORE_YOU_BOOK}/${PH_ITINERARY_ID}`,
	// COMFY_SCORE_ROUTE: "/customize/:searchRegion/inclusions/comfy-score/:itineraryId"
	COMFY_SCORE_ROUTE: `${INCLUSIONS_BASE}/${COMFY_SCORE}/${PH_ITINERARY_ID}`,
	//SPLIT_PRICE_ROUTE: "/customize/:searchRegion/inclusions/split-price/:itineraryId"
	SPLIT_PRICE_ROUTE: `${INCLUSIONS_BASE}/${SPLIT_PRICE}/${PH_ITINERARY_ID}`,
	//CHANGE_LOCALE_ROUTE: "/customize/:searchRegion/inclusions/split-price/:itineraryId"
	CHANGE_LOCALE_ROUTE: `${INCLUSIONS_BASE}/${CHANGE_LOCALE}/${PH_ITINERARY_ID}`,
	// BLOCK_CARD_FLIGHT: "/customize/:searchRegion/inclusions/block-card/flight/:configKey/:itineraryId"
	BLOCK_CARD_FLIGHT: `${INCLUSIONS_BASE}/${BLOCK_CARD_FLIGHT}/${PH_CONFIG_KEY}/${PH_ITINERARY_ID}`,
	// FLIGHT_DETAILS_BLOCK_CARD: "/customize/:searchRegion/inclusions/flight-details/block-card/:configKey/:itineraryId"
	FLIGHT_DETAILS_BLOCK_CARD: `${INCLUSIONS_BASE}/${FLIGHT_DETAILS}/${BLOCK_CARD}/${PH_CONFIG_KEY}/${PH_ITINERARY_ID}`,
	// BLOCK_CARD_HOTEL: "/customize/:searchRegion/inclusions/block-card/hotel/:configKey/:itineraryId"
	BLOCK_CARD_HOTEL: `${INCLUSIONS_BASE}/${BLOCK_CARD_HOTEL}/${PH_CONFIG_KEY}/${PH_ITINERARY_ID}`,
	// BLOCK_CARD_CUSTOM: "/customize/:searchRegion/inclusions/block-card/custom/:itineraryId"
	BLOCK_CARD_CUSTOM: `${INCLUSIONS_BASE}/${BLOCK_CARD_CUSTOM}/${PH_ITINERARY_ID}`,
	// BLOCK_CARD_CUSTOM_KEY: "/customize/:searchRegion/inclusions/block-card/custom/:customKey/:itineraryId"
	BLOCK_CARD_CUSTOM_KEY: `${INCLUSIONS_BASE}/${BLOCK_CARD_CUSTOM}/${BLOCK_CARD_KEY}/${PH_ITINERARY_ID}`,
	// HOTEL_DETAILS_BLOCK_CARD: "/customize/:searchRegion/inclusions/hotel-details/block-card/:configKey/:itineraryId"
	HOTEL_DETAILS_BLOCK_CARD: `${INCLUSIONS_BASE}/${HOTEL_DETAILS}/${BLOCK_CARD}/${PH_CONFIG_KEY}/${PH_ITINERARY_ID}`,
	// BEFORE_YOU_BOOK_ROUTE: "/customize/:searchRegion/inclusions/cancellation-policy/:itineraryId"
	CANCELLATION_POLICY_ROUTE: `${INCLUSIONS_BASE}/${CANCELLATION_POLICY}/${PH_ITINERARY_ID}`,
	// SPLIT_HOTEL_ROUTE: "/customize/:searchRegion/inclusions/split-hotel/:itineraryId/:duration?/:orderOfStay?"
	SPLIT_HOTEL_ROUTE: `${INCLUSIONS_BASE}/${SPLIT_HOTEL}/:sourceHotelCostingKey/${PH_ITINERARY_ID}/`,
}

const newHomePageRoute = {
	HOME_PAGE: '/',
	HOTELS_PAGE: '/hotels',
	DEALS_PAGE: '/deals',
	DEALS_SIGNUP_PAGE: '/deals/signup',
	PACKAGES_PAGE: '/holiday-packages',
	PACKAGES_SEARCH_PAGE: '/holiday-packages/search',
	DEALS_SEARCH_PAGE: '/deals/search',
}

const routingPageType = {
	inclusion: INCLUSIONS_VIEW,
	itinerary: ITINERARY_VIEW,
}

const getGetCostingHelperRoute = ({
	pathname = '',
	itineraryId = '',
	target = 'login',
}) => {
	const isItineraryPage = checkIndexOf(pathname, ['/view/', '/inclusions/'])
	const key = getPackageKeyFromPathname(pathname)

	let loc = '/' + key
	if (!itineraryId.length) {
		loc = `/${key}/get-cost`
	} else if (!isItineraryPage) {
		loc = `/${key}/get-cost/${itineraryId}`
	}

	return loc + '/' + target
}

const itineraryModalsRouteHelper = ({
	itineraryId = '',
	regionCode = null,
	parentPage = ITINERARY_VIEW,
	target = null,
	location,
	customParams,
	retainQueryString,
}) => {
	if (location) {
		parentPage = getPageName(location)
	}
	let loc = `/${PH_CUSTOMIZE}/${regionCode}/${parentPage}`

	if (
		target &&
		target !== HOTEL_ALTERNATES_DETAILS &&
		target !== ACTIVITY_ALTERNATES_DETAILS &&
		target !== ALTERNATE_FLIGHTS_DETAIL
	) {
		loc = `${loc}/${target}`
	}

	switch (target) {
		case ACTIVITY_DETAILS:
		case ACTIVITY_DETAILS_PREVIEW:
		case ACTIVITY_ALTERNATES:
			loc = `${loc}/${customParams.configKey}`
			break
		case ACTIVITY_ALTERNATES_DETAILS:
			loc = `${loc}/${ACTIVITY_ALTERNATES}/${customParams.configKey}/${itineraryId}/details/${customParams.activityCode}`
			break
		case ENABLE_TOTEM:
			loc = `${loc}/${customParams.dayIdentifier}`
			break
		case ALTERNATE_TRANSFER_MODE:
			loc = `${loc}/${customParams.transferMode}/${customParams.prevCityKey}/${customParams.cityKey}`
			break
		case ALTERNATE_IMAGE_GALLERY:
			loc = `${loc}/${customParams.configKey}/${itineraryId}/details/${customParams.hotelCode}`
			break
		case IMAGE_GALLERY:
		case HOTEL_DETAILS:
		case HOTEL_ALTERNATES:
			loc = `${loc}/${customParams.configKey}`
			break
		case PROPERTY_GALLERY:
		case WATERSPORTS_GALLERY:
		case HIGHLIGHTS_GALLERY:
		case ROOM_DETAILS:
			loc = `${loc}/${customParams.configKey}/${
				customParams.hotelRoomKey
			}/${itineraryId}/${
				customParams.altHotelRoomKey || customParams.hotelRoomKey
			}`
			break
		case HOTEL_ALTERNATE_ROOMS:
			loc = `${loc}/${customParams.configKey}/${customParams.hotelRoomKey}`
			break
		case HOTEL_ALTERNATES_DETAILS:
			loc = `${loc}/${HOTEL_ALTERNATES}/${customParams.configKey}/${itineraryId}/details/${customParams.hotelCode}`
			break
		case FLIGHT_DETAILS:
		case FLIGHT_ALTERNATES:
			loc = `${loc}/${customParams.configKey}`
			break
		case ALTERNATE_FLIGHTS_DETAIL:
			loc = `${loc}/${FLIGHT_ALTERNATES}/${customParams.configKey}/${itineraryId}/details`
			break
		case RENTAL_CAR_DETAILS:
		case RENTAL_CAR_ALTERNATES:
		case CHANGE_RENTAL_CAR_INSURANCE:
			loc = `${loc}/${customParams.configKey}`
			break
		case TRAIN_DETAILS:
		case TRAIN_ALTERNATES:
			loc = `${loc}/${customParams.configKey}`
			break
		case BUS_ALTERNATES:
		case BUS_DETAILS:
			loc = `${loc}/${customParams.configKey}`
			break
		case FERRY_ALTERNATES:
		case FERRY_DETAILS:
			loc = `${loc}/${customParams.configKey}`
			break
		case CHANGE_VISA:
			loc = `${loc}/${customParams.visaKey}`
			break
		case RATE_MATCH_ACTIVITY:
			loc = `${loc}/${customParams.configKey}/${customParams.called_from}`
			break
		case RATE_MATCH_RENTAL_CAR:
			loc = `${loc}/${customParams.configKey}/${customParams.called_from}`
			break
		case RATE_MATCH_HOTEL_ROOM:
			loc = `${loc}/${customParams.configKey}/${customParams.identifier}/${customParams.called_from}`
			break
		case RATE_MATCH_FLIGHT:
			loc = `${loc}/${customParams.configKey}/${customParams.called_from}`
			break
		case RATE_MATCH_TRAIN:
			loc = `${loc}/${customParams.configKey}/${customParams.called_from}`
			break
		case RATE_MATCH_FERRY:
			loc = `${loc}/${customParams.configKey}/${customParams.called_from}`
			break
		case RATE_MATCH_TRANSFER:
			loc = `${loc}/${customParams.configKey}/${customParams.called_from}`
			break
		case RATE_MATCH_TOTAL_COST:
			loc = `${loc}/${customParams.called_from}`
			break

		case SPLIT_HOTEL:
			loc = `${loc}/${customParams.sourceHotelCostingKey}`
			break
		case FLIGHT_DETAILS_BLOCK_CARD:
		case BLOCK_CARD_FLIGHT:
			// eslint-disable-next-line no-console
			console.log('BLOCK_CARD_HOTEL--', loc, `${loc}/${customParams.configKey}`)
			loc = `${loc}/${customParams.configKey}`
			break
		case HOTEL_DETAILS_BLOCK_CARD:
		case BLOCK_CARD_HOTEL:
			loc = `${loc}/${customParams.configKey}`
			break
		case BLOCK_CARD_CUSTOM:
			loc = `${loc}${
				customParams && customParams.customKey
					? `/${customParams.customKey}`
					: ''
			}`
			break
		case UPDATE_COST:
		case GET_COST:
		case GET_COST_DEPARTURE_CITY_ROUTE:
		case GET_COST_DEPARTURE_DATE_ROUTE:
		case GET_COST_DURATION_ROUTE:
		case GET_COST_PAX_ROUTE:
		case EDIT_TITLE:
		case LOGIN:
		case EMAIL_QUOTE:
		case EMAIL_QUOTE_ADMIN:
		case SHARE_ITINERARY:
		case CHANGE_INSURANCE:
		case CBR:
		default:
			loc = `${loc}`
	}

	const routesWithItineraryId = [
		ALTERNATE_IMAGE_GALLERY,
		HOTEL_ALTERNATES_DETAILS,
		ACTIVITY_ALTERNATES_DETAILS,
		ALTERNATE_FLIGHTS_DETAIL,
		PROPERTY_GALLERY,
		WATERSPORTS_GALLERY,
		HIGHLIGHTS_GALLERY,
		ROOM_DETAILS,
	]

	let queryString = ''
	// retain query parameters if it is there
	if (retainQueryString && !is_server()) {
		queryString = window.location.search
	}

	if (!routesWithItineraryId.includes(target))
		return loc + '/' + itineraryId + queryString
	else return loc + queryString
}

const getPageName = location => {
	if (location.pathname.indexOf(INCLUSIONS_VIEW) > -1) {
		return INCLUSIONS_VIEW
	}
	return ITINERARY_VIEW
}

const ITINERARY_ROUTES = {
	ITINERARY_VIEW_ROUTE,
	EDIT_TRIP_ROUTE,
	GET_COST_ROUTE,
	GET_COST_DEPARTURE_CITY_ROUTE,
	GET_COST_DEPARTURE_DATE_ROUTE,
	GET_COST_DURATION_ROUTE,
	GET_COST_PAX_ROUTE,
	EDIT_TITLE_ROUTE,
	UPDATE_COST_ROUTE,
	COSTING_IN_PROGRESS_ROUTE,
	SHARE_ITINERARY_ROUTE,
	LOGIN_ROUTE,
	CBR_ROUTE,
	CBR_WHATSAPP_ROUTE,
	SIGNUP_ROUTE,
	HOTEL_DETAILS_ROUTE,
	HOTEL_ALTERNATE_GALLERY_ROUTE,
	HOTEL_GALLERY_ROUTE,
	HOTEL_ALTERNATES_ROUTE,
	HOTEL_ALTERNATES_DETAILS_ROUTE,
	HOTEL_ALTERNATE_ROOMS_ROUTE,
	ACTIVITY_DETAILS_ROUTE,
	ACTIVITY_DETAILS_PREVIEW_ROUTE,
	ACTIVITY_ALTERNATES_ROUTE,
	ACTIVITY_ALTERNATES_DETAILS_ROUTE,
	ALTERNATE_TRANSFER_MODE_ROUTE,
	RATE_MATCH_ACTIVITY_ROUTE,
	RATE_MATCH_TRANSFER_ROUTE,
	RATE_MATCH_HOTEL_ROOM_ROUTE,
	RATE_MATCH_TOTAL_ROUTE,
	ENABLE_TOTEM_ROUTE,
	BEFORE_YOU_BOOK_ROUTE,
	COMFY_SCORE_ROUTE,
	COMFY_SCORE_ITINERARY_ROUTE,
	SPLIT_HOTEL_ROUTE,
	IMAGE_GALLERY_ROUTE_WITH_ITINERARY_ID,
	IMAGE_GALLERY_ROUTE,
	RATE_MATCH_RENTAL_CAR_ROUTE,
	RATE_MATCH_FERRY_ROUTE,
	FERRY_DETAILS_ROUTE,
	FERRY_ALTERNATE_ROUTE,
	CHANGE_RENTAL_CAR_INSURANCE_ROUTE,
	ALTERNATE_RENTAL_CAR_ROUTE,
	RATE_MATCH_FLIGHT_ROUTE,
	ALTERNATE_FLIGHTS_ROUTE,
	ALTERNATE_FLIGHTS_DETAIL_ROUTE,
	FLIGHT_DETAILS_ROUTE,
	FLIGHT_DETAILS_BLOCK_CARD_ROUTE,
	BLOCK_CARD_HOTEL_ROUTE,
	BLOCK_CARD_FLIGHT_ROUTE,
	HOTEL_DETAILS_BLOCK_CARD_ROUTE,
	EMAIL_QUOTE_ROUTE,
	EMAIL_QUOTE_ADMIN_ROUTE,
}

export {
	PH_ITINERARY_ID,
	ITINERARY_VIEW,
	INCLUSIONS_VIEW,
	GET_COST,
	DEPARTURE_CITY,
	ARRIVAL_CITY,
	DEPARTURE_DATE,
	DURATION,
	ROOM_INFO,
	UPDATE_COST,
	EDIT_TRIP,
	LOGIN,
	EDIT_TITLE,
	SIGNUP,
	SHARE_ITINERARY,
	CHANGE_LOCALE,
	CBR,
	CBR_WHATSAPP,
	ENABLE_TOTEM,
	HOTEL_DETAILS,
	ROOM_DETAILS,
	PROPERTY_GALLERY,
	WATERSPORTS_GALLERY,
	HIGHLIGHTS_GALLERY,
	IMAGE_GALLERY,
	ALTERNATE_IMAGE_GALLERY,
	HOTEL_ALTERNATES,
	HOTEL_ALTERNATE_ROOMS,
	HOTEL_ALTERNATES_DETAILS,
	ACTIVITY_DETAILS,
	ACTIVITY_DETAILS_PREVIEW,
	ACTIVITY_ALTERNATES,
	ALTERNATE_TRANSFER_MODE,
	ACTIVITY_ALTERNATES_DETAILS,
	ALTERNATE_FLIGHTS_DETAIL,
	FLIGHT_DETAILS,
	FLIGHT_ALTERNATES,
	TRAIN_DETAILS,
	TRAIN_ALTERNATES,
	BUS_ALTERNATES,
	FERRY_ALTERNATES,
	RENTAL_CAR_DETAILS,
	RENTAL_CAR_ALTERNATES,
	CHANGE_RENTAL_CAR_INSURANCE,
	RATE_MATCH,
	EMAIL_QUOTE,
	EMAIL_QUOTE_ADMIN,
	CHANGE_INSURANCE,
	CHANGE_VISA,
	RATE_MATCH_HOTEL_ROOM,
	RATE_MATCH_ACTIVITY,
	RATE_MATCH_RENTAL_CAR,
	RATE_MATCH_FLIGHT,
	RATE_MATCH_TRAIN,
	RATE_MATCH_FERRY,
	RATE_MATCH_TRANSFER,
	RATE_MATCH_TOTAL_COST,
	COSTING_IN_PROGRESS,
	getGetCostingHelperRoute,
	itineraryModalsRouteHelper,
	ITINERARY_ROUTES,
	inclusionsRoute,
	newHomePageRoute,
	routingPageType,
	BUS_DETAILS,
	FERRY_DETAILS,
	BEFORE_YOU_BOOK,
	COMFY_SCORE,
	SPLIT_PRICE,
	SPLIT_HOTEL,
	BLOCK_CARD_FLIGHT,
	BLOCK_CARD_HOTEL,
	BLOCK_CARD_CUSTOM,
	FLIGHT_DETAILS_BLOCK_CARD,
	HOTEL_DETAILS_BLOCK_CARD,
	CANCELLATION_POLICY,
	IMAGE_GALLERY_KEY,
	EMAIL,
}

export const MALDIVES_ROUTES = {
	MALDIVES_SLUG_KEY,
	MALDIVES_INCLUSIONS_BASE_URL,
	REQUEST_CALLBACK,
	LANDING_ROUTE,
	LISTING_ROUTE,
	RESORT_SLUG_ROUTE,
	RESORTS_SLUG_MODAL_ROUTE,
	MALDIVES_LISTING_CBR_ROUTE,
	MALDIVES_RESORTS_CBR_ROUTE,
	MALDIVES_RESORTS_WHATSAPP_ROUTE,
	GET_COST_DEPARTURE_CITY_ROUTE: MALDIVES_GET_COST_DEPARTURE_CITY_ROUTE,
	GET_COST_DEPARTURE_DATE_ROUTE: MALDIVES_GET_COST_DEPARTURE_DATE_ROUTE,
	GET_COST_DURATION_ROUTE: MALDIVES_GET_COST_DURATION_ROUTE,
	GET_COST_ROOMS_ROUTE: MALDIVES_GET_COST_ROOMS_ROUTE,
	RESORT_SLUG_LOGIN_ROUTE,
	RESORT_SLUG_SIGNUP_ROUTE,
	RESORT_SLUG_GCM_ROUTE,
	RESORT_SLUG_GCM_DEPARTURE_CITY_ROUTE,
	RESORT_SLUG_GCM_DEPARTURE_DATE_ROUTE,
	RESORT_SLUG_GCM_DURATION_ROUTE,
	RESORT_SLUG_GCM_ROOMS_ROUTE,
	MALDIVES_LISTING_LOGIN,
	MALDIVES_LISTING_SIGN_UP,
	MALDIVES_LISTING_GCM_UPDATE_COST_ROUTE,
	LANDING_PAGE_KEY,
	SPEEDBOAT_IMAGE_ROUTE,
	MALDIVES_LANDING_EXPLORE_ALL_ROUTE,
	MALDIVES_LANDING_FILTER_BY_PRICE,
}
